<div *ngIf="admOuTechSelect=='tech'">
  <button class="btn btn-outline-primary" (click)="addtypeAdresseCompleteTech()">{{ step12.add  | translate }}</button>
  <div *ngFor="let obj of admOuTech?.tech; let i = index">
      <button class="btn btn-outline-primary" (click)="removetypeAdresseCompleteTech(i)">{{ step12.remove  | translate }}</button>
      <app-type-adresse-complete [uid]="'tech'+getUid()+'_index_'+(i+1)" [parentForm]="parentForm"
[disabled]="disabled"
[filtreRG]="'tech'"
[nbIteration]="i"
 [typeAdresseComplete]="obj"></app-type-adresse-complete>
  </div>
</div>
<div *ngIf="admOuTechSelect=='adm'">
  <button class="btn btn-outline-primary" (click)="addtypeAdresseCompleteAdm()">{{ step12.add  | translate }}</button>
  <div *ngFor="let obj of admOuTech?.adm; let i = index">
      <button class="btn btn-outline-primary" (click)="removetypeAdresseCompleteAdm(i)">{{ step12.remove  | translate }}</button>
      <app-type-adresse-complete [uid]="'adm'+getUid()+'_index_'+(i+1)" [parentForm]="parentForm"
[disabled]="disabled"
[filtreRG]="'adm'"
[nbIteration]="i"
 [typeAdresseComplete]="obj"></app-type-adresse-complete>
  </div>
</div>



